module.exports = __webpack_public_path__ + "media/images/btn_arrow-e8adddd3dfceb01cef4eff4d46086cd1.svg";